module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    attrs: {
      "src": _vm.src,
      "url": _vm.url,
      "banKey": _vm.banKey,
      "handleUrlChange": _vm.handleUrlChange,
      "isAdmin": _vm.isAdmin,
      "ensureIsAdmin": _vm.ensureIsAdmin
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78816777"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 484
// module chunks = 8